import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { defaultValues } from './model';
import { deliverablesFormSchema } from './schemas';

export function useFormDefinition({ agreementId }: { agreementId: number }) {
  return useForm({
    resolver: zodResolver(deliverablesFormSchema),
    defaultValues: { ...defaultValues, agreement_id: agreementId },
    shouldFocusError: true,
  });
}
